//@flow

// Vendors
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Modal } from '../../../../modals';
import Trans from '../../../../Trans/Trans';
import { TxButton, TxButtonMode } from 'texkit-ui';

// Actions
import { closeModal } from '../../../../../../reducers/modal/modalActions';

// Styles
import './dps-packet-rejected-modal.scss';

const DpsPacketRejectedModal = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.modal);

  // Switch to adjusted SCSS if on iOS device
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test( userAgent );

  const getDocumentType = docType => {
    switch (docType) {
      case 'Completed Application Form':
        return 'Completed_Application_Form';
      case 'Proof of Identity Documents':
        return 'Proof_of_Identity_Documents';
      case 'U.S. Citizenship Document':
        return 'US_Citizenship_Document';
      case 'Acceptable Texas Residency Document(s)':
        return 'Acceptable_Texas_Residency_Documents';
      case 'Driver License Surrender Form (DL-174)':
        return 'Driver_License_Surrender_Form';
    }

    return '';
  };

  const getReasonType = docType => {
    switch (docType) {
      case 'Incomplete document':
        return 'INCOMPLETE_DOCUMENT';
      case 'Illegible document':
        return 'ILLEGIBLE_DOCUMENT';
      case 'Missing signature':
        return 'MISSING_SIGNATURE';
      case 'Other':
        return 'OTHER';
      case 'Expired document':
        return 'EXPIRED_DOCUMENT';
    }

    return '';
  };

  return (
    <Modal
      name="DpsPacketRejectedModal"
      className={
        ios
          ? 'rejected-packet-modal-ios'
          : 'rejected-packet-modal'
      }
    >
      <h2 className="h1 modal-title-general">
        <Trans file="dps" id="Packet_Rejected_Modal_Title" />
      </h2>
      <p className="modal-description-general">
        <Trans file="dps" id="Packet_Rejected_Modal_Description" />
      </p>
      <div className="modal-content-data">
        {data &&
          data.surrenderdlDocuments &&
          data.surrenderdlDocuments.map((doc, index) => {
            return (
              <div key={index} className="modal-document">
                <div className="modal-document-title">
                  <Trans file="dps" id={getDocumentType(doc.type)} />
                </div>
                <ul className="modal-document-description">
                  {doc.rejectionReasonList.length > 0 && (
                    <li className="modal-document-description-text">
                      <strong>
                        <Trans file="dps" id="Reasons" fallback="Reasons" />
                      </strong>{' '}
                      {doc.rejectionReasonList
                        .map(reason => (
                          <Trans
                            key={reason.code}
                            file="dps"
                            id={getReasonType(reason.code)}
                          />
                        ))
                        .reduce((prev, curr) => [prev, ', ', curr])}
                    </li>
                  )}
                  {doc.rejectionReasonList.map(
                    (reason, index) =>
                      reason.comment && (
                        <li
                          key={index}
                          className="modal-document-description-text"
                        >
                          <strong>
                            <Trans
                              file="dps"
                              id="Other_Comments"
                              fallback="Other Comments"
                            />
                          </strong>{' '}
                          {reason.comment}
                        </li>
                      )
                  )}
                </ul>
              </div>
            );
          })}
      </div>
      <p className="modal-create-packet-description">
        <Trans file="dps" id="New_Packet_creation_Description" />
      </p>
      <TxButton
        className="modal-close-button"
        mode={TxButtonMode.Primary}
        onClick={() => {
          if (data.handleAuditVerification) {
            data.handleAuditVerification(false, false, true);
          }
          dispatch(closeModal('DpsPacketRejectedModal'));
        }}
      >
        <Trans file="dps" id="Create_New_Packet" fallback="Create new packet" />
      </TxButton>
    </Modal>
  );
};

export default DpsPacketRejectedModal;
